import { STUB_ORG_CONTEXT } from '../../../fixture/context';

const improvements: Accelerate.ImprovementsState = {
  userContext: { ...STUB_ORG_CONTEXT },
  improvements: [],
  searchResults: [],
  providerSearchResults: [],
  procedureSearchResults: [],
  dictionaryValues: {
    numRows: 0,
    columnNames: [],
    rowValues: []
  }
};

export { improvements };
